{
  "columnResizer": "Změna velikosti sloupce",
  "loading": "Načítání...",
  "loadingMore": "Načítání dalších...",
  "resizeColumn": "Změnit velikost sloupce",
  "sortAscending": "Seřadit vzestupně",
  "sortDescending": "Seřadit sestupně"
}
